"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var config_1 = __importDefault(require("config"));
var use_stores_1 = require("hooks/use-stores");
var Login_1 = __importDefault(require("components/core/login/Login"));
var SplashScreen_1 = __importDefault(require("components/core/SplashScreen"));
var Root_1 = __importDefault(require("./components/core/Root"));
var Routes = function () {
    var _a = react_1.useState(false), userCheck = _a[0], setUserCheck = _a[1];
    var _b = react_1.useState(false), exiting = _b[0], setExiting = _b[1];
    var history = react_router_dom_1.useHistory();
    var userStore = use_stores_1.useStores().userStore;
    react_1.useEffect(function () {
        var localUser = localStorage.getItem(config_1.default.storage_keys.USER);
        if (localUser === null) {
            history.replace("/login");
        }
        else {
            if (history.location.pathname === "/login")
                history.replace("/");
            userStore.setData(JSON.parse(localUser));
        }
        setTimeout(function () {
            setExiting(true);
            setTimeout(function () {
                setUserCheck(true);
            }, 500);
        }, 1000);
    }, []);
    return userCheck ? (react_1.default.createElement("div", null,
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "/login", component: Login_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/", component: Root_1.default })))) : react_1.default.createElement(SplashScreen_1.default, { exiting: exiting });
};
exports.default = Routes;
